import { ComponentPropsWithoutRef, forwardRef } from 'react';

import Item from '@/components/common/Footer/FooterItem';

type Props = ComponentPropsWithoutRef<'div'>;

const Footer = forwardRef<HTMLDivElement, Props>(({ children, ...props }, ref) => {
  return (
    <div {...props} ref={ref} id="kakaoFoot" className="kakao_foot" role="contentinfo">
      <div className="inner_footer">
        <h2 className="screen_out">서비스 이용정보</h2>
        <a href="https://www.kakaocorp.com" className="link_copyright" rel="noopener noreferrer" target="_blank">
          © <strong>Kakao Corp.</strong>
        </a>
        <strong className="screen_out">광고 약관 및 정책</strong>
        <ul className="list_policy">{children}</ul>
      </div>
    </div>
  );
});

Footer.displayName = 'Footer';

export default Object.assign(Footer, {
  Item
});
